import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';

// Components
import { Button, Input, Text } from '@beef/ui-kit';

// Selectors
import { getPersonalFamilyInfo, hasFTNumberedFamily } from '../../../pages/Home/containers/FamilyWithBeeline/selectors';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const AddNumberPopup = ({
  title,
  label,
  description,
  buttonText,
  maskFormat,
  handleCreateInvite,
  validateCellPhone,
  isLoading,
  inviteError,
  setInviteError,
  wholesalePriceTitle,
  byNumberedPriceTitle,
}) => {
  const [inputValue, setInputValue] = useState('');
  const { invitePriceData } = useSelector(getPersonalFamilyInfo);
  const { familyNumberedPriceToggleEnabled } = useSelector(hasFTNumberedFamily);

  // TODO: выпилить TYPE_BY_NUMBERED, т.к. бэк должен слать string BY_NUMBERED, а не number в invitePriceData
  const TYPE_BY_NUMBERED = 1;

  const InvitePriceTypes = {
    WHOLESALE: 'WHOLESALE',
    BY_NUMBERED: 'BY_NUMBERED',
  };

  const isShowPrice = !!invitePriceData;
  const { price, unit, type } = invitePriceData || {};
  const isPriceTitle = byNumberedPriceTitle || wholesalePriceTitle;
  const isByNumbered = (type === InvitePriceTypes.BY_NUMBERED) || (type === TYPE_BY_NUMBERED);

  const selectedVariant = familyNumberedPriceToggleEnabled ? 'main' : 'secondary';

  const handleSubmitForm = (event) => handleCreateInvite(event, inputValue);
  const handleChangeInput = (event) => {
    setInputValue(event.target.value);
    setInviteError('');
  };

  return (
    <form onSubmit={handleSubmitForm} className={cn('form')}>
      {title && (
        <div className={cn('form__title')}>
          <Text
            size="size2-m"
            tagType="h3"
          >
            {title}
          </Text>
        </div>
      )}
      {label && (
        <div className={cn('form__input')}>
          <Input
            placeholder="+7"
            value={inputValue}
            onChange={handleChangeInput}
            label={label}
            name="cellNumber"
            maskSettings={{
              mask: '_',
              format: maskFormat,
            }}
            errorMessage={inviteError}
          />
        </div>
      )}
      {description && (
        <div className={cn('form__description')}>
          <Text
            color="grey50"
            size="size5-r-s"
          >
            {description}
          </Text>
        </div>
      )}
      {isShowPrice && (
        <div className={cn('form__price')}>
          {isPriceTitle && (
            <Text color="grey50" size="size5-r-s">
              {isByNumbered ? byNumberedPriceTitle : wholesalePriceTitle}
            </Text>
          )}
          <Text size="size5-r-s">{`${price} ${unit}`}</Text>
        </div>
      )}
      {buttonText && (
        <div className={cn('form__actions')}>
          <Button
            isLoading={isLoading}
            type="submit"
            variant={selectedVariant}
            size="l"
            disabled={!validateCellPhone(inputValue)}
          >
            {buttonText}
          </Button>
        </div>
      )}
    </form>
  );
};

AddNumberPopup.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  maskFormat: PropTypes.string,
  handleCreateInvite: PropTypes.func,
  validateCellPhone: PropTypes.func,
  isLoading: PropTypes.bool,
  inviteError: PropTypes.string,
  setInviteError: PropTypes.func,
  wholesalePriceTitle: PropTypes.string,
  byNumberedPriceTitle: PropTypes.string,
};

export { AddNumberPopup };
